import { render, staticRenderFns } from "./PrestacaoCard.vue?vue&type=template&id=5234c298&"
import script from "./PrestacaoCard.vue?vue&type=script&lang=js&"
export * from "./PrestacaoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports